import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { ConfigService } from '@fpr/core/services/config.service';
import { AuthStatusService } from '../services/auth-status.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private readonly authStatusService = inject(AuthStatusService);
    private readonly configService = inject(ConfigService);


    private readonly EXCLUDED_URLS = [
        '/errors'
    ];

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // don't modify the request, if it's part of excludedUrls
        if (this.EXCLUDED_URLS.some(url => (url === req.url))) {
            return next.handle(req);
        }

        return from(this.handle(req, next));

    }

    private async handle(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
        try {
            const token = await this.authStatusService.getAuthToken().toPromise();
            const authReq = req.clone({
                headers: req.headers.set('Authorization', `BEARER ${token}`)
            });

            return next.handle(authReq).toPromise();
        } catch (_err) {
            // return original request, which should receive an unauthorized error
            return next.handle(req).toPromise();
        }

    }

}
